import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const RunIcon = () => (
  <SvgIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6665 14.3099V5.6849C6.6665 5.44878 6.74984 5.25087 6.9165 5.09115C7.08317 4.93142 7.27762 4.85156 7.49984 4.85156C7.56928 4.85156 7.6422 4.86198 7.71859 4.88281C7.79498 4.90365 7.86789 4.9349 7.93734 4.97656L14.729 9.28906C14.854 9.3724 14.9478 9.47656 15.0103 9.60156C15.0728 9.72656 15.104 9.85851 15.104 9.9974C15.104 10.1363 15.0728 10.2682 15.0103 10.3932C14.9478 10.5182 14.854 10.6224 14.729 10.7057L7.93734 15.0182C7.86789 15.0599 7.79498 15.0911 7.71859 15.112C7.6422 15.1328 7.56928 15.1432 7.49984 15.1432C7.27762 15.1432 7.08317 15.0634 6.9165 14.9036C6.74984 14.7439 6.6665 14.546 6.6665 14.3099Z"
    />
  </SvgIcon>
);
